import { motion } from "framer-motion";

const problems = [
  {
    n: "01",
    title: "Aucune présence en ligne",
    text: "Vos clients cherchent sur Google. Sans site, vos concurrents prennent votre place.",
  },
  {
    n: "02",
    title: "Un site obsolète",
    text: "Design daté et mobile bancal = perte immédiate de crédibilité.",
  },
  {
    n: "03",
    title: "Un référencement local inexistant",
    text: "« Artisan Albi », « boulangerie Gaillac »… si vous n'apparaissez pas, vous perdez ces prospects chaque jour.",
  },
  {
    n: "04",
    title: "Un manque de crédibilité",
    text: "Un site amateur dévalue vos prestations. Un site soigné justifie vos tarifs.",
  },
  {
    n: "05",
    title: "Une expérience mobile catastrophique",
    text: "70 % des recherches locales se font sur mobile. Site mal adapté = client perdu en 3 secondes.",
  },
];

export const Problems = () => (
  <section id="problemes" data-testid="problems-section" className="py-24 md:py-32 bg-paper">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <p className="font-mono-label text-ink/60"><span className="rule" />Constat</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight">
            Pourquoi tant d’entreprises peinent à trouver des clients{" "}
            <em className="font-light italic">sur internet</em> ?
          </h2>
          <p className="mt-8 text-ink/65 leading-relaxed max-w-md">
            La concurrence digitale s’est durcie dans le Tarn. Voici les 5
            freins les plus courants.
          </p>
        </div>

        <div className="lg:col-span-7">
          <ul className="divide-y divide-ink/10 border-t border-b border-ink/10">
            {problems.map((p, i) => (
              <motion.li
                key={p.n}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="py-8 flex gap-6 group"
                data-testid={`problem-${i}`}
              >
                <span className="font-mono-label text-ink/40 pt-1 shrink-0">{p.n}</span>
                <div>
                  <h3 className="font-display text-2xl text-ink">{p.title}</h3>
                  <p className="mt-3 text-ink/65 leading-relaxed">{p.text}</p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
